var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNowServingPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "65px",
    viewBox: "0 0 43 65",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NowServingPin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "50%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.444444,1.000000),rotate(90.000000),scale(1.000000,1.962200),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "50%",
    gradientTransform: "translate(0.500000,0.500000),scale(0.533748,1.000000),rotate(90.000000),scale(1.000000,1.962200),translate(-0.500000,-0.500000)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000000",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.9888827%",
    cy: "19.9895943%",
    fx: "42.9888827%",
    fy: "19.9895943%",
    r: "35.8679203%",
    gradientTransform: "translate(0.429889,0.199896),scale(1.000000,0.546398),rotate(90.000000),translate(-0.429889,-0.199896)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA8A8",
    stopOpacity: 0.5,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.9423215,26.7697327 L16.6628105,34.2473758 C16.480103,39.1361339 16.082723,44.0101055 15.4706704,48.8692905 C15.3967809,49.4585693 14.8915765,49.9009627 14.2925215,49.9009627 C13.6934665,49.9009627 13.1882621,49.4585693 13.1143727,48.8692905 C12.5027393,44.0146765 12.1053592,39.1407049 11.9222325,34.2473758 L11.6430359,26.7699404 C4.59415306,25.3892729 -0.163507863,18.8223774 0.768649975,11.7602629 C1.70080781,4.69814841 8.00272475,-0.434383333 15.1726771,0.0290504449 C22.3426295,0.492484222 27.918789,6.39276191 27.917871,13.5150676 C27.9180521,19.9628868 23.3224787,25.5127828 16.9423215,26.7697327 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-51.3%",
    y: "-20.0%",
    width: "202.7%",
    height: "156.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0800498188 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-33.0%",
    y: "-10.0%",
    width: "166.0%",
    height: "136.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.254755435 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Service-Map",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-722.000000, -294.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(222.000000, 254.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "right-side-content",
    transform: "translate(480.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NowServingIcon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NowServingPin",
    transform: "translate(27.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "url(#radialGradient-1)",
    opacity: 0.135586504,
    cx: 14.5,
    cy: 50,
    rx: 4.5,
    ry: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3",
    fill: "url(#radialGradient-2)",
    opacity: 0.135586504,
    cx: 21.6664645,
    cy: 44.2944444,
    rx: 13.6664645,
    ry: 7.29444444
  }), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#ED66FE",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-3)",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    fill: "#FFFFFF",
    cx: 11,
    cy: 9,
    r: 3
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNowServingPin);
export default __webpack_public_path__ + "static/media/NowServingPin.5d8f4b698243b281bf39b86df363b73d.svg";
export { ForwardRef as ReactComponent };